export class VendorBankAccount {
    id: number;
    organizationId: number;
    vendorId: number;
    accountHolderName: string;
    routingNumber: string;
    last4: string;
    accountType: string;
    hasStripePaymentMethod: boolean;
    createdAt: string;
    updatedAt: string;

    constructor(data: any) {
        this.id = data.id || 0;
        this.organizationId = data.organizationId || 0;
        this.vendorId = data.vendorId || 0;
        this.accountHolderName = data.accountHolderName || '';
        this.routingNumber = data.routingNumber || '';
        this.last4 = data.last4 || '';
        this.accountType = data.accountType || '';
        this.hasStripePaymentMethod = data.hasStripePaymentMethod ?? false;
        this.createdAt = data.createdAt || '';
        this.updatedAt = data.updatedAt || '';
    }
}
